import { render, staticRenderFns } from "./AddAndAttachResponsibilityDialog.vue?vue&type=template&id=932b8e0a"
import script from "./AddAndAttachResponsibilityDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAndAttachResponsibilityDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports